<template>
  <div class="addfollowup">
    <div class="addfollowup--header">
      <div class="addfollowup--header--title">
        <div class="title--back iconfont" @click="handleToCallRoute">&#xe600;</div>
        <div class="title--text">资产检查信息</div>
        <div class="title--back"></div>
      </div>
    </div>
    <div class="addfollowup--line"></div>
    <div class="addfollowup--info">
      <div class="addfollowup--info--item">
        <div class="item--text">资产名产</div>
        <div class="item--desc">{{assetName}}</div>
        <div class="item--icon iconfont"></div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">资产保管位置</div>
        <div class="item--desc">{{assetLocation}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">资产类型</div>
        <div class="item--desc">{{assetTypeName}}</div>
      </div>

      <div class="addfollowup--info--item">
        <div class="item--text">抵债金额(万元)</div>
        <div class="item--desc">{{payDebtAmount}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">账面金额(万元)</div>
        <div class="item--desc">{{balanceAmount}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">权属单位</div>
        <div class="item--desc">{{ownerCom}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">数量/面积</div>
        <div class="item--desc">{{areaInfo}}</div>
      </div>

      <div class="addfollowup--info--item" @click=" (approveStatus==='997' || approveStatus==='111') && handleToRecordToMap()">
        <div class="item--text">检查地址</div>
        <div class="item--desc">{{this.$store.state.locationData.address}}</div>
        <div class="item--icon iconfont" v-if="(approveStatus==='997' || approveStatus==='111')">
          <template>&#xe62b;</template>
        </div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">检查时间</div>
        <div class="item--desc">{{this.$store.state.locationData.locationDate}}</div>
        <div class="item--icon iconfont"></div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">参与人</div>
        <div class="item--desc">{{actornames}}</div>
      </div>
      <div class="addfollowup--info--txt">
        本次检查现场情况及问题:
        <div class="item-txt">{{checkDesc}}</div>
      </div>
      <div class="addfollowup--info--txt">
        下一步举措建议:
        <div class="item-txt">{{nextMeasures}}</div>
      </div>
      <div
        class="addfollowup--info--swiper"
        v-if="docEReceiveList.length > 0"
      >
        <swiper class="echw-fb-swiper" :options="swiperOption">
          <swiper-slide
            class="echw-fb-swiper-slide"
            v-for="(imgItem,imgIndex) in docEReceiveList"
            :key="imgIndex"
          >
            <img @click.stop="handleToFollowupDetailImg(docEReceiveList,imgIndex)" class="swiper--img" :src="imgItem.downloadUrl" alt="">
          </swiper-slide>
          <div v-if="false" class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      <div class="addfollowup--info--txt" v-if="flowApproveInfoList.length > 0">
        <div
          class="txt-border"
          v-for="info in flowApproveInfoList"
          :key="info.id"
        >
          <div>审批意见:  {{info.approveRemark?info.approveRemark:'同意'}}</div>
          <div>审批人:    {{info.nowFlowUserName}}</div>
          <div>批准时间:  {{info.approveTime}}</div>
        </div>
      </div>
      <div class="addfollowup--info--txt" v-if="readonlyFlag">
        <div class="txt-border">
          <md-textarea-item
            ref="demo0"
            autosize
            clearable
            class="example"
            v-model="approveRemark"
            placeholder="审批意见:"
          />
        </div>
      </div>
    </div>

    <div class="addfollowup--footer" v-if="readonlyFlag">
      <div class="addfollowup--footer--save" @click="handleToCheckAgree">同意</div>
      <div class="addfollowup--footer--save" @click="handleToCheckBack">退回</div>
    </div>
    <div class="follow--big--img">
      <div class="md-example-child md-example-child-image-reader">
        <md-image-viewer
          v-model="imgShow"
          :list="imgsList"
          :has-dots="true"
          :initial-index="imgIndex">
        </md-image-viewer>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { ImageViewer, Tag, ImageReader, Icon, TextareaItem } from 'mand-mobile'
import { postjson } from '../api/api'

export default {
  name: 'VerifyDetail',
  components: {
    [TextareaItem.name]: TextareaItem,
    [ImageViewer.name]: ImageViewer,
    [Tag.name]: Tag,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon
  },
  data () {
    return {
      swiperOption: {
        centeredSlides: false, // 当前slide居中显示
        slidesPerView: 3, // 1是显示1个banner, 'auto'自适应
        spaceBetween: 12, // slide间隔（px）
        loop: false,
        autoplay: false,
        delay: 5000, // 自动轮播， 默认 3000 ms
        simulateTouch: true, // 鼠标拖拽
        allowTouchMove: true, // 触摸滑动
        lazyLoading: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      },
      imgsList: [], // 全屏图片列表
      imgShow: false, // 控制图片全屏显示
      imgIndex: 0, // 控制图片全屏显示
      id: '', // 单条资产数据id
      approveStatus: '', // 资产状态
      assetName: '', // 资产名称
      assetLocation: '', // 资产保管位置
      assetType: '', // 资产类型
      assetTypeName: '', // 资产类型文本
      address: '', // 资产地址
      lat: '', // 资产地址经度
      lng: '', // 资产地址维度
      locationDate: '', // 资产地位时间
      actornames: '', // 参与人
      checkDesc: '', // 本次检查情况及问题
      nextMeasures: '', // 下一步举措
      docEReceiveList: [], // 资产现场图片
      mmRecordStaffList: [], // 参与人列表
      flowApproveInfoList: [], // 审批意见列表
      payDebtAmount: '', // 抵债金额(万元)
      balanceAmount: '', // 账面金额(万元)
      ownerCom: '', // 权属单位
      areaInfo: '', // 数量/面积
      approveRemark: '', // 审批意见
      readonlyFlag: 'true' // 审批权限控制
    }
  },
  beforeMount () {
    if (JSON.parse(localStorage.getItem('assetspostData'))) {
      const assetspostData = JSON.parse(localStorage.getItem('assetspostData'))
      this.handelToDetailCheckData(assetspostData, 'verifylist')
    } else {
      this.handelToDetailCheckData(this.$route.params.data, this.$route.params.routerTag)
    }
  },
  destroyed () {
    this.$store.commit('delLocationInfo', '')
  },
  methods: {
    // 处理数据
    handelToDetailCheckData (item, routerName) {
      this.id = item.id
      this.approveStatus = item.approveStatus
      this.assetName = item.assetName
      this.assetLocation = item.assetLocation
      this.assetType = item.assetType
      this.assetTypeName = item.assetTypeName
      const payLoad = { ...this.$store.state.locationData }
      payLoad.address = item.address
      payLoad.lng = item.lng
      payLoad.lat = item.lat
      payLoad.locationDate = item.locationDate
      this.$store.commit('setLocationFunc', payLoad)
      this.actornames = item.actornames
      this.checkDesc = item.checkDesc
      this.nextMeasures = item.nextMeasures

      this.payDebtAmount = item.payDebtAmount
      this.balanceAmount = item.balanceAmount
      this.ownerCom = item.ownerCom
      this.areaInfo = item.areaInfo

      this.docEReceiveList = item.docEReceiveList
      this.mmRecordStaffList = item.mmRecordStaffList
      this.flowApproveInfoList = item.flowApproveInfoList
      if (routerName === 'hisassets') {
        this.readonlyFlag = false
      }
    },
    // 路由返回
    handleToCallRoute () {
      if (this.$route.params.routerTag) {
        this.$router.push({ name: this.$route.params.routerTag })
      } else {
        this.$router.push({ name: 'verifylist' })
      }
    },
    // 同意
    async handleToCheckAgree () {
      const postData = {
        id: this.id,
        approveStatus: this.approveStatus,
        assetName: this.assetName,
        assetLocation: this.assetLocation,
        assetType: this.assetType,
        assetTypeName: this.assetTypeName,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        actornames: this.actornames,
        checkDesc: this.checkDesc,
        nextMeasures: this.nextMeasures,

        payDebtAmount: this.payDebtAmount,
        balanceAmount: this.balanceAmount,
        ownerCom: this.ownerCom,
        areaInfo: this.areaInfo,

        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.mmRecordStaffList,
        flowApproveInfoList: this.flowApproveInfoList,
        approveRemark: this.approveRemark
      }
      const routerName = this.$route.params.routerTag ? this.$route.params.routerTag : 'hisassets'
      const result = await postjson('/api/CBMS-APP/mmassetcheck/submitflow', postData)
      if (result.success) {
        this.$toast.success({
          message: '已同意',
          onClose: () => {
            this.$router.push({ name: routerName })
          }
        })
      } else {
        this.$toast.success('同意失败')
      }
    },
    // 退回
    async handleToCheckBack () {
      if (!this.approveRemark) {
        this.$toast.success('审批意见不能为空')
        return
      }
      const postData = {
        id: this.id,
        approveStatus: this.approveStatus,
        assetName: this.assetName,
        assetLocation: this.assetLocation,
        assetType: this.assetType,
        assetTypeName: this.assetTypeName,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        actornames: this.actornames,
        checkDesc: this.checkDesc,
        nextMeasures: this.nextMeasures,
        payDebtAmount: this.payDebtAmount,
        balanceAmount: this.balanceAmount,
        ownerCom: this.ownerCom,
        areaInfo: this.areaInfo,
        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.mmRecordStaffList,
        flowApproveInfoList: this.flowApproveInfoList,
        approveRemark: this.approveRemark
      }
      const routerName = this.$route.params.routerTag ? this.$route.params.routerTag : 'hisassets'
      const result = await postjson('/api/CBMS-APP/mmassetcheck/callbackflow', postData)
      if (result.success) {
        this.$toast.success({
          message: '已退回',
          onClose: () => {
            this.$router.push({ name: routerName })
          }
        })
      } else {
        this.$toast.success('退回失败')
      }
    },
    // 跳转到地图页面
    handleToRecordToMap () {
      const lat = this.$store.state.locationData.lat
      const lng = this.$store.state.locationData.lng
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({ name: 'marketmap', params: { localName: 'verifydetail', modifyTag, routerName, id, lat, lng } })
    },
    // 点击轮播上图片触发的函数
    handleToFollowupDetailImg (imgList, imgIndex) {
      imgList.forEach(item => {
        this.imgsList.push(item.downloadUrl)
      })
      this.imgIndex = imgIndex
      this.imgShow = true
    }
  },
  watch: {
    imgShow (newVal, oldVal) {
      if (!newVal) {
        this.imgsList = []
        this.imgIndex = 0
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    const assetspostData = {
      id: this.id,
      approveStatus: this.approveStatus,
      assetName: this.assetName,
      assetLocation: this.assetLocation,
      assetType: this.assetType,
      assetTypeName: this.assetTypeName,
      address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
      lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
      lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
      locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
      actornames: this.actornames,
      checkDesc: this.checkDesc,
      nextMeasures: this.nextMeasures,
      payDebtAmount: this.payDebtAmount,
      balanceAmount: this.balanceAmount,
      ownerCom: this.ownerCom,
      areaInfo: this.areaInfo,
      docEReceiveList: this.docEReceiveList,
      mmRecordStaffList: this.mmRecordStaffList,
      flowApproveInfoList: this.flowApproveInfoList,
      approveRemark: this.approveRemark
    }
    if (to.name === 'marketmap' && from.name === 'verifydetail') {
      localStorage.setItem('assetspostData', JSON.stringify(assetspostData))
      next()
    } else {
      localStorage.removeItem('assetspostData')
      next()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addfollowup
  position : relative
  width : 100vw
  min-height : 100vh
  background-color : #f7f7f7
  overflow-x : hidden
  overflow-y : scroll
  padding-bottom : 116px
  .addfollowup--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addfollowup--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding :0 16px
        box-sizing : border-box
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
  .addfollowup--line
    height : 85px
    width : 100vw
  .addfollowup--info
    .addfollowup--info--item
      display : flex
      justify-content : center
      align-items : center
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &:nth-child(1)
        margin-top : 0
      .item--text
        width : 200px
      .item--desc
        flex : 1
        text-align : left
        text-indent : 32px
      .item--report
        flex : 1
        text-align : right
        color : #007aff
        text-decoration: underline
      .item--radio
        flex : 1
        &>>>.van-radio-group
          padding-left : 16px
      .item--icon
        width : 100px
        text-align : right
        font-size: 34px
        color : #4282e1
      &>>>.md-field-item
        width : 100vw
      &>>>.md-field-item-content:before
        border-bottom : none
    .addfollowup--info--camera
      display : flex
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--img--icon
        text-align : center
        line-height : 47px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 64px
    .addfollowup--info--img
      margin : 0 8px
      .md-example-child-reader
        .image-reader-list
          background-color : #ffffff
          float : left
          width : 100%
          .image-reader-item
            position : relative
            float : left
            width : 23.5%
            padding-bottom : 23.5%
            margin-bottom : 2%
            margin-right : 2%
            background : #FFF
            box-shadow : 0 5px 20px rgba(197, 202, 213, .25)
            box-sizing : border-box
            list-style : none
            border-radius : 4px
            background-size : cover
            overflow : hidden
            &:nth-of-type(4n)
              margin-right : 0
            &.add
              .md-icon
                position : absolute
                top : 40%
                left : 50%
                transform : translate(-50%, -50%)
                opacity : .5
              p
                position : absolute
                top : 50%
                left : 0
                width : 100%
                margin-top : 15px
                font-size : 22px
                color : #CCC
                text-align : center
            .image-reader-item-del
              position : absolute
              top : 0
              right : 0
              z-index : 3
              opacity : .8
              .md-icon-close
                font-size : 24px
    .addfollowup--info--person
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--persons--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .item--persons--desc
        display : flex
        align-items : center
        padding : 16px 0
        border-bottom : 1px solid #8b8787
        .desc--person
          background-color : #4282e1
          margin-right : 32px
          width : 100px
          height : 100px
          line-height : 100px
          text-align : center
          border-radius : 50%
          color : #ffffff
          font-family: MyriadPro-Regular
          font-size: 28px
          font-weight: normal
          font-stretch: normal
        .desc--person--plus
          font-size : 32px
    .addfollowup--info--version
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .version--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .version--item
        display : flex
        align-items : center
        padding : 16px 0
        line-height : 1.5
        background-color : #ffffff
        border-bottom : 1px solid #8b8787
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .version--item--text
          width : 250px
        .version--item--desc
          flex : 1
        .version--item--icon
          width : 100px
          text-align : right
          font-size: 34px
        &.active
          background-color : #007aff
          .version--item--text,.version--item--icon
            color : #ffffff
    .addfollowup--info--txt
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .txt-border
        margin : 8px
        padding : 8px
        border-radius : 12px
        border : 1px solid #bdb9b9
      .item-txt
        text-indent : 64px
    .addfollowup--info--swiper
      padding : 16px
      height : 210px
      margin-top : 16px
      background-color : #ffffff
      .echw-fb-swiper
        width : 100%
        height : 210px
        .echw-fb-swiper-slide
          height : 210px
          img
            width : 100%
            height : 100%
    .addfollowup--info--remark
      margin: 8px
      border-radius : 12px
      border : 1px solid #bdb9b9
  .addfollowup--footer
    position : fixed
    left : 0
    bottom :0
    width : 100vw
    display : flex
    z-index : 100
    .addfollowup--footer--save,.addfollowup--footer--del
      flex : 1
      text-align : center
      padding : 32px 0
      background-color : #eabf62
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
    .addfollowup--footer--save
      border-right : 1px solid #ffffff
    .addfollowup--footer--del
      border-left : 1px solid #ffffff
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .visit--title
      position : fixed
      top: 0
      left: 0
      width : 100vw
      z-index : 12
      display : flex
      background-color : #687591
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
        color : #ffffff
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
        color : #ffffff
    .visit--line
      height : 80px
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : left
        .text-title
          padding-bottom : 8px
          font-size: 32px
          font-weight: normal
          font-stretch: normal
        .text-desc
          padding-top : 8px
          color : #007aff
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
  &>>>.md-popup-cancel
    font-size : 38px
    padding-left : 28px
  &>>>.md-popup-confirm
    font-size : 38px
    padding-right : 28px
</style>
